/**
 * KAN-989: показывать ли дату следующего списания абонентки с баланса.
 *
 * Не показываем, если списания не будет: тариф отменяется, не ACTIVE,
 * бесплатный, непубличный (Партнёр) или срок задан "навсегда" (2100 год).
 * Цена и is_public в ответе /subscription-plans/current/ могут отсутствовать,
 * поэтому срок дальше 10 лет тоже считается бессрочным тарифом.
 */
import type { OrganizationSubscription } from '@/types/subscription';

/** Срок дальше этого числа лет от сегодня: тариф бессрочный, списаний нет. */
export const PERPETUAL_PERIOD_YEARS = 10;

export function isFreePrice(value: string | number | null | undefined): boolean {
  if (value === null || value === undefined || value === '') return false;
  const num = Number(value);
  return Number.isFinite(num) && num <= 0;
}

export function nextChargeDate(
  subscription: OrganizationSubscription,
  now: Date = new Date()
): string | null {
  const end = subscription.current_period_end;
  if (subscription.status !== 'ACTIVE' || subscription.cancel_at_period_end || !end) return null;
  const { plan } = subscription;
  if (plan.is_public === false) return null;
  if (isFreePrice(plan.price_monthly_rub)) return null;
  const limit = new Date(now);
  limit.setFullYear(limit.getFullYear() + PERPETUAL_PERIOD_YEARS);
  if (new Date(end).getTime() > limit.getTime()) return null;
  return end;
}
